


























import { Component, Vue, Prop } from "vue-property-decorator";
import { getBiduiBiaoqian } from "@/request/idr";
@Component({})
export default class IdrBiduiBiaoqian extends Vue {
  @Prop()
  private tongues: any;
  private message: any = {};
  /**
   * @description 获取标签信息
   */
  private fetchMessage() {
    const ids: any[] = [];
    this.tongues.map((item: any) => {
      ids.push(item.tongue_id);
    });
    const params: any = {
      tongue_ids: ids
    };
    getBiduiBiaoqian(this, params).then((data: any) => {
      this.message = data;
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchMessage();
  }
}
